"use strict";
exports.__esModule = true;
exports.chart_color_blue_300 = {
  "name": "--pf-v5-chart-color-blue-300",
  "value": "#06c",
  "var": "var(--pf-v5-chart-color-blue-300, #06c)"
};
exports["default"] = exports.chart_color_blue_300;